var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-header",class:{ 'fd-hide': _vm.isMobile, 'qq-style': _vm.isQQ }},[_c('div',{staticClass:"header-logo",on:{"click":_vm.toGo}},[_c('img',{attrs:{"src":require("@imgs/logo.png"),"alt":"logo"}})]),_c('HeaderMenu'),_c('HeaderAccount')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }